import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_mof_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  mof_fee_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  quarter: number;
  after_final_step_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.JsonDatatypeInterface;
  amount_cogs: number;
  amount_discount: number;
  amount_net: number;
  amount_open_balance: number;
  amount_signum: number;
  amount_std: number;
  amount_tax_gst: number;
  amount_tax_wht: number;
  amount_txn: number;
  amount_json: fromDatatype.JsonDatatypeInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: number;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_so_item_pkid: number;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy: boolean;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  is_synced: boolean;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_status_guid: fromDatatype.GuidDataFieldInterface;
  xtn_workflow_updated_at: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  gen_doc_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  engagement_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_mof_doc_hdr_RowClass implements
  bl_aat_mof_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  mof_fee_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  quarter: number;
  after_final_step_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.JsonDatatypeInterface;
  amount_cogs: number;
  amount_discount: number;
  amount_net: number;
  amount_open_balance: number;
  amount_signum: number;
  amount_std: number;
  amount_tax_gst: number;
  amount_tax_wht: number;
  amount_txn: number;
  amount_json: fromDatatype.JsonDatatypeInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: number;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_so_item_pkid: number;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy: boolean;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  is_synced: boolean;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_status_guid: fromDatatype.GuidDataFieldInterface;
  xtn_workflow_updated_at: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  gen_doc_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  engagement_name: fromDatatype.VarcharDatatypeInterface;
}
